import { useCustomMutation } from '@refinedev/core';
import { Company } from 'src/secret-menu/hooks/useCompanies';

type UpdateFinioFirmNameInput = {
  finioFirmName: string | null;
};

export const useUpdateFinioFirmName = (companyId: string) => {
  const { mutateAsync, isLoading, error } = useCustomMutation<Company>();

  const updateFinioFirmName = async (input: UpdateFinioFirmNameInput) => {
    return mutateAsync({
      url: `admin/companies/${companyId}/finio-firm-name`,
      method: 'put',
      values: input,
    });
  };

  return { updateFinioFirmName, isLoading, error };
};
